// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AgendaAdicionaServicoNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Nested input for servicos array in Agenda_AdicionaOrcamentoServicoNoCompromissoInput
 */
import { registerContract } from './validate'

export interface AgendaAdicionaServicoNestedInput {
orcamento_servico_id: number
compromisso_servico_valor: number
}

registerContract('AgendaAdicionaServicoNestedInput', {
  orcamento_servico_id:      { type: 'number',  required: true },
  compromisso_servico_valor: { type: 'number',  required: true },
})
